import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading)
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f7f9f7",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            border: "2.5px solid #e0e0e0",
            borderTopColor: "#006663",
            borderRadius: "50%",
            animation: "spin 0.7s linear infinite",
          }}
        />
      </div>
    );
  if (user) return <Navigate to="/dashboard" />;

  return children;
};

export default PublicRoute;
